
$(document).ready( function() {
    const hasQueryArrivalDate = document.querySelector('#listing-availability-container input#has-query-arrival-date');
    if (hasQueryArrivalDate) {
        $('#listing_query_arrival_date.date-picker').data('datepicker').hide = function () {};
        $('#listing_query_arrival_date.date-picker').datepicker('show');
    }

    const arrivalSelect = document.querySelector('#arrival_date_select');
    if (arrivalSelect) {
        const initialDate = arrivalSelect.value ? new Date(arrivalSelect.value) : null;
        if (initialDate) updateDiscountBadges(initialDate);

        arrivalSelect.addEventListener('change', function() {
            const date = this.value ? new Date(this.value) : null;
            if (date) updateDiscountBadges(date);
        });
    }
});

function isDiscountActivated(expirationNumberOfDays, arrivalDate, discountType) {
	const today = new Date()
	today.setHours(0, 0, 0, 0)
	const arrival = new Date(arrivalDate)
	arrival.setHours(0, 0, 0, 0)
	const expiration = new Date(arrival)
	expiration.setDate(arrival.getDate() - expirationNumberOfDays)

    switch (discountType) {
        case 'early_bird':
            return today <= expiration;
        case 'last_minute':
            return today >= expiration;
        default:
            return false;
    }
}

function isFixedDateDiscountActivated(startDate, expirationDate) {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const start = new Date(startDate)
    start.setHours(0, 0, 0, 0)
    const expiration = new Date(expirationDate)
    expiration.setHours(0, 0, 0, 0)
    return today >= start && today <= expiration;
}

function updateDiscountBadges(arrivalDate) {
    const listingPcks = document.querySelectorAll('#listing_side_list ul li');

    listingPcks.forEach(pck => {
        const {expirationType, expirationNumberOfDays, discountType, discountStartDate, discountExpirationDate} = pck.dataset;
        const dsctBadge = pck.querySelector('label .package-discount-badge');
        if (!dsctBadge || !expirationType) return;

        let active = true;
        if (expirationType === 'rolling_window') {
            active = isDiscountActivated(expirationNumberOfDays, arrivalDate, discountType);
        } else if (expirationType === 'fixed_date') {
            active = isFixedDateDiscountActivated(discountStartDate, discountExpirationDate);
        }

        dsctBadge.classList.toggle('hide', !active);
    });
}
